module.exports = __webpack_public_path__ + "img/commonButton.e83ccc4a.png";